<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý báo cáo sự cố</div>
      </div>
      <div class="card card-w-title">
        <div class="list-data">
          <div class="list-title">
            <span class="p-m-0">Danh sách báo cáo sự cố</span>
          </div>
          <BaseCommon v-if="dataModel"
            :key="componentKey"
            :listData="listData"
            :model="dataModel"
            :filterDefault="filters"
            :actions="getRowActions()"
            v-on:action-click="onActionClicked"
          ></BaseCommon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseCommon from '../common'
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
      filters: {},
      listData: [],
      dataModel: null,
      componentKey: 0
    }
  },
  mounted () {
    this.initData();
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initData'
  },
  methods: {
    initData() {
      setTimeout(async () => {
        if (this.checkVisible('report_violation', 'list')) {
          await this.initParams();
        }
      }, 1000);
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    async initParams() {
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      if(this.$route.params != undefined && this.$route.params != null && this.$route.params.organization_id != undefined && this.$route.params.organization_id != '') {
        this.filters['organization_id'] = this.$route.params.organization_id;
      }
      if(this.$route.params != undefined && this.$route.params != null && this.$route.params.phone_number != undefined && this.$route.params.phone_number != '') {
        this.filters['phone_number'] = this.$route.params.phone_number;
      }
      this.modelName = 'report_violation';
      var whereKey = {product_serial_number: {product: {status: {_in: [1]}, production_status: {_in: [0, 1]}, categories: {status: {_eq: 1}}}}};
      var variables = {
        where_key: whereKey,
        orderBy: {
          id: 'desc',
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      this.dataModel = DataServices.getModel(this.modelName);
      this.dataModel.processData(list);
      list.sort((a,b)=> (a.processStatusSortTmp - b.processStatusSortTmp ||  b.id - a.id ));//new Date(b.created_at) - new Date(a.created_at)
      this.listData = list;
      this.componentKey++;
      this.$store.commit('setLoading', false);
    },
    
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'view':
          if(this.checkVisible('report_violation', 'view')) {
            this.$router.push(action.path + '/' + data.data[action.key])
          }
          break;
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        if(that.checkVisible('report_violation', 'view')) {
          buttons.view = { name: 'view', text: 'Xem', isText: true, key: 'id', path: `/admin/report-violation/view`}
          if (that.dataModel.actions) {
            var modelaction = that.dataModel.actions(rowData)
            Object.assign(buttons, modelaction);
          }
        }
        return buttons
      }
      return actions
    },
    cancelFilter() {
      this.filters = {};
    }
  }
}
</script>
<style lang="scss">
.box-filters{ margin: 15px 0;
  .p-formgroup-inline { display: flex;flex-wrap: wrap; align-items: flex-start;
    .p-field{ margin-right: 50px; margin-bottom: 15px;
      &:last-child{margin: 0; position: relative;}
      label{display: block;}
      .p-dropdown, input{width: 230px;}
      .btn-cancel{width: 90px;position: absolute; top: 30px;}
    }
  }
}
.external-link{ color: #0066FF; cursor: pointer;
  &.black-color {
    span{color: #000;}
  }
  span{color: #199ED8;}
}
</style>